export const CATEGORIES = [
    "ideas",
    "projects",
    "family",
    "friends",
    "health",
    "admin",
    "uncategorized"
];
export const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;
export const MAX_VOICE_SECONDS = 5 * 60;
